import MainMenuPanel from "./MainMenuPanel";
import MultiGamesPanel from "./MultiGamesPanel";
import SingleGamesPanel from "./SingleGamesPanel";
import FamePanel from './FamePanel';

export default function GamesView({show}) {
    return <>
        {show === "menu" && <MainMenuPanel/>}
        {show === "single" && <SingleGamesPanel/>}
        {show === "multi" && <MultiGamesPanel/>}
        {show === "fame" && <FamePanel/>}
    </>
}
